<template>
	<div class="footer-container">
		<div class="main-w">
			<!-- 友情链接 -->
			<div class="links">
				<!-- 分割线 -->
				<div class="line"></div>
				<!-- 版权 -->
				<div class="row cb Copyright">
					<div class="info">
						<p>Copyright@2014 All Rights Reserved. 版权所有 健康科普研究中心</p>
						<p>地址：北京市东城区东单三条9号 邮编：100730 京ICP备2020042203号-2</p>
            <p>联系电话：010-85002999 / 176-1002-8051</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { links } from '@/utils/links';
export default {
	data() {
		return {
			links: links
		};
	}
};
</script>

<style lang="less" scoped>
.footer-container {
	margin-top: 50px;
	background: #007575;
	color: #fff;
	font-size: 14px;

	.links {
		width: 100%;
		padding-bottom: 20px;
		background: #007575;
		.title {
			padding: 34px 0;
			font-size: 18px;
			font-weight: bold;
		}
	}
	.link {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		a {
			text-decoration: none;
			margin-bottom: 30px;
			font-size: 14px;
			display: block;
			width: 140px;
			&:hover {
				color: #6dcdba;
			}
		}
	}
	// 分割线
	.line {
		width: 100%;
		height: 1px;
		background-color: #ececec2a;
	}
	// 版权消息
	.Copyright {
		margin-top: 23px;
		.info {
			color: #ffffff;
			line-height: 32px;
			font-size: 14px;
		}
		.qr {
			.img {
				width: 94px;
				height: 94px;
				margin-bottom: 4px;
			}
			color: #ffffff;
			font-size: 14px;
		}
	}
}
</style>
